import React, { Component } from "react";
import axios from "axios";
import "./App.css";
import Atelier from "./Components/Atelier";
import AtelierContent from "./Components/AtelierContent";
import Map from "./Components/Map";
import Spinner from "./Components/Spinner";
import Dropdown from "react-dropdown";
import "react-dropdown/style.css";
import moment from "moment";

const apiUrl = "https://www.monmomentmagique.com/wp-json/wp/v2/ateliers";

const apiUrlCat =
  "https://www.monmomentmagique.com/wp-json/wp/v2/categories?parent=6&orderby=id";

const apiUrlAmbassadrice =
  "https://www.monmomentmagique.com/wp-json/wp/v2/users?per_page=500";

const urlString = document.location.href;
const url = new URL(urlString);
const startAtl = url.searchParams.get("id");
const startFilter = url.searchParams.get("type");

class App extends Component {
  static defaultProps = {
    startAtl: startAtl !== null ? startAtl : 5436,
    startFilter: startFilter !== null ? startFilter : undefined,
  };
  state = {
    ateliers: [],
    categories: [],
    ambassadrices: [],
    choice: this.props.startFilter,
    filteredAteliers: [],
    currentAtl: this.props.startAtl,
    currentAtlData: [],
    displayMap: true,
    displayHover: false,
    choiceLabel: "Tous les ateliers",
  };

  componentDidMount() {
    this.getAllAteliers();
    this.getAllAmbassadrice();
    this.getCategories();
    this.getCurrentAtl();
    this.setAteliersList();
  }

  componentDidUpdate(previousProps, previousState) {
    if (previousState.choice !== this.state.choice) {
      this.updateAteliersList();
    }

    if (previousState.currentAtl !== this.state.currentAtl) {
      this.getCurrentAtl();
    }
  }

  getAllAteliers = () => {
    axios.get(apiUrl + "?per_page=5000").then((res) => {
      res.data = res.data
        .filter((data) => this.checkDate(data.acf.ateliers_date))
        .map((data) => data);
      const ateliers = res.data;
      ateliers.sort(function compare(a, b) {
        var dateA = new moment(a.acf.ateliers_date, "M-D-YYYY");
        var dateB = new moment(b.acf.ateliers_date, "M-D-YYYY");
        return dateA - dateB;
      });
      this.setState({
        ateliers,
        filteredAteliers: ateliers,
      });
    });
  };

  checkDate = (date) => {
    const dateAtelier = new moment(date, "M-D-YYYY");
    const today = new moment();
    return dateAtelier.isAfter(today, "day");
  };

  getAllAmbassadrice = () => {
    axios.get(apiUrlAmbassadrice).then((res) => {
      const ambassadrices = res.data;
      this.setState({
        ambassadrices,
      });
    });
  };

  getCurrentAtl = () => {
    const apiUrlAtl = apiUrl + "/" + this.state.currentAtl + "?_embed";
    axios.get(apiUrlAtl).then((res) => {
      const currentAtlData = res.data;
      this.setState({
        currentAtlData,
      });
      if (startAtl) {
        this.setState({
          displayMap: false,
        });
      }
    });
  };

  getCategories = () => {
    axios.get(apiUrlCat).then((res) => {
      const categories = res.data;
      this.setState({ categories });
    });
  };

  setAteliersList = () => {
    if (this.props.startFilter) {
      axios
        .get(apiUrl + "?categories=" + this.props.startFilter)
        .then((res) => {
          const filteredAteliers = res.data;
          this.setState({
            filteredAteliers,
          });
        });
    }
  };

  updateAteliersList = () => {
    const atl = this.state.ateliers;
    const catcat = this.state.categories;
    const test = catcat
      .filter((c) => c.id === this.state.choice)
      .map((c) => c.name);
    let filteredAteliers = [];

    if (this.state.choice === "All") {
      filteredAteliers = atl;
    } else {
      for (let i = 0; i < atl.length; i++) {
        for (let j = 0; j < atl[i].categories.length; j++) {
          if (atl[i].categories[j] === parseInt(this.state.choice, 10)) {
            filteredAteliers.push(atl[i]);
          }
        }
      }
      this.setState({
        choiceLabel: test,
      });
    }

    this.setState({ filteredAteliers });
  };

  setChoice = (e) => {
    this.setState({
      choice: e.target.value,
    });
  };

  setChoiceV2 = (choice) => {
    this.setState({
      choice: choice.value,
      choiceLabel: choice.label,
    });
  };

  showContent = (id) => {
    this.setState({
      currentAtl: id,
      displayMap: false,
    });
  };

  changeDisplayMap = () => {
    this.setState({ displayMap: true });
  };

  emailModal = (email, info) => {
    const elem = document.getElementById("input_4_15");
    // elem.value = info;
    elem.setAttribute("value", info);
    // const elem2 = document.querySelector(".champ-email-ambassadrice input");
    const elem2 = document.getElementById("input_4_16");
    // elem2.value = email;
    elem2.setAttribute("value", email);
  };

  displayMarkerInfo = (id) => {
    this.setState({
      currentAtl: id,
      displayMap: false,
    });
  };

  handleMouseEnter = (id) => {
    this.setState({
      hoveredAtl: id,
      displayHover: true,
    });
  };
  handleMouseLeave = () => {
    this.setState({
      hoveredAtl: undefined,
      displayHover: false,
    });
  };

  render() {
    const options = [];
    options.push({
      value: "All",
      label: "Tous les types d'atelier",
      className: "custom_option bleu_f",
    });
    this.state.categories.map((cat) =>
      options.push({
        value: cat.id,
        label: cat.name,
        className: cat.acf.selectionner_une_couleur,
      })
    );

    const defaultOption = options[0];
    return (
      <div className="App page-atelier page-sidebar-content">
        <main className="site-main">
          <div className="sidebar wow fadeInLeft">
            <aside className="sidebar_page sidebar_atelier">
              <h1>
                <strong>Trouvez</strong> un atelier
              </h1>

              <Dropdown
                options={options}
                onChange={this.setChoiceV2}
                //onChange={this._onSelect}
                value={defaultOption}
                placeholder={
                  this.state.choiceLabel
                } /* "Tous les types d'atelier" */
                //className="select_atelier"
                controlClassName="select_atelier"
                //menuClassName="select_atelier"
              />
              {/* <select
                onChange={this.setChoice}
                value={this.state.choice}
                className="select_atelier "
              >
                <option value="All">Tous les types d'atelier</option>
                {this.state.categories.map(cat => (
                  <option
                    key={cat.id}
                    value={cat.id}
                    className={
                      "custom_option " + cat.acf.selectionner_une_couleur
                    }
                  >
                    {cat.name}
                  </option>
                ))}
              </select> */}

              <div className="list-container">
                <ul className="list_ateliers list">
                  {!this.state.filteredAteliers ? (
                    <div>
                      <Spinner />
                    </div>
                  ) : (
                    this.state.filteredAteliers.map((atelier) => (
                      <Atelier
                        key={atelier.id}
                        atlId={atelier.id}
                        categoriesId={atelier.categories}
                        categories={this.state.categories}
                        url={atelier.link}
                        date={atelier.acf.ateliers_date}
                        hdebut={atelier.acf.ateliers_heure_debut}
                        hfin={atelier.acf.ateliers_heure_fin}
                        localisation={atelier.acf.ateliers_localisation}
                        showContent={this.showContent}
                        handleMouseEnter={this.handleMouseEnter}
                        handleMouseLeave={this.handleMouseLeave}
                        complet={atelier.acf.ateliers_complet}
                      />
                    ))
                  )}
                </ul>
              </div>
            </aside>
          </div>
          {this.state.displayMap ? (
            <Map
              data={this.state.filteredAteliers}
              displayMarkerInfo={this.displayMarkerInfo}
              displayHover={this.state.displayHover}
              hoveredAtl={this.state.hoveredAtl}
            />
          ) : (
            <AtelierContent
              data={this.state.currentAtlData}
              categories={this.state.categories}
              currentAtl={this.state.currentAtl}
              changeDisplayMap={this.changeDisplayMap}
              ambassadrices={this.state.ambassadrices}
              emailModal={this.emailModal}
              ateliers={this.state.ateliers}
            />
          )}
        </main>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js